import { render } from "./ModalLogout.vue?vue&type=template&id=17b63ef4"
import script from "./ModalLogout.vue?vue&type=script&lang=js"
export * from "./ModalLogout.vue?vue&type=script&lang=js"
script.render = render

export default script